/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse2003OffersModalities model module.
 * @module model/InlineResponse2003OffersModalities
 * @version v1
 */
class InlineResponse2003OffersModalities {
    /**
     * Constructs a new <code>InlineResponse2003OffersModalities</code>.
     * @alias module:model/InlineResponse2003OffersModalities
     */
    constructor() { 
        
        InlineResponse2003OffersModalities.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse2003OffersModalities</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse2003OffersModalities} obj Optional instance to populate.
     * @return {module:model/InlineResponse2003OffersModalities} The populated <code>InlineResponse2003OffersModalities</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse2003OffersModalities();

            if (data.hasOwnProperty('normal')) {
                obj['normal'] = ApiClient.convertToType(data['normal'], 'Number');
            }
            if (data.hasOwnProperty('fct')) {
                obj['fct'] = ApiClient.convertToType(data['fct'], 'Number');
            }
            if (data.hasOwnProperty('dual')) {
                obj['dual'] = ApiClient.convertToType(data['dual'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} normal
 */
InlineResponse2003OffersModalities.prototype['normal'] = undefined;

/**
 * @member {Number} fct
 */
InlineResponse2003OffersModalities.prototype['fct'] = undefined;

/**
 * @member {Number} dual
 */
InlineResponse2003OffersModalities.prototype['dual'] = undefined;






export default InlineResponse2003OffersModalities;

